import {
	DocumentItemType,
	DocumentItemViewModel,
	DocumentsViewModel,
	ListLocationViewModel,
	ListLocationModel,
} from "../SharePoint/common";
import { DocumentStoreType } from "../common";
import { environmentHttpClient } from "client/Api/httpClient";
import { WebDavModels } from "../WebDav/webDav";

type BookmarkGenericProperties = {
	id: number;
	name: string;
	itemType: DocumentItemType;
	extension: string;
	sortOrder: number;
};

export type SharePointBookmarkModel = BookmarkGenericProperties & {
	storeType: DocumentStoreType.SharePoint;
	location: ListLocationViewModel;
	itemId: number;
};

export type WebDavBookmarkModel = BookmarkGenericProperties & {
	storeType: DocumentStoreType.WebDav;
	serverId: number;
	fileId: string;
};

export type BookmarkModel = SharePointBookmarkModel | WebDavBookmarkModel;

export function getBookmarks(
	signal?: AbortSignal
): Promise<BookmarkModel[]> {
	return environmentHttpClient.get<BookmarkModel[]>(
		"/Documents/Bookmarks/List",
		null,
		{ signal }
	);
}

export interface SharePointModels {
	view: DocumentsViewModel;
	item: DocumentItemViewModel;
}

export function getSharePointModels(
	bookmarkId: number,
	signal?: AbortSignal
): Promise<SharePointModels> {
	return environmentHttpClient.get<SharePointModels>(
		`/Documents/Bookmarks/GetSharePointModels/${bookmarkId}`,
		null,
		{ signal }
	);
}

export function getWebDavModels(
	bookmarkId: number,
	signal?: AbortSignal
): Promise<WebDavModels> {
	return environmentHttpClient.get<WebDavModels>(
		`/Documents/Bookmarks/GetWebDavModels/${bookmarkId}`,
		null,
		{ signal }
	);
}

export function removeBookmarks(
	ids: number[],
	signal?: AbortSignal
): Promise<void> {
	return environmentHttpClient.post<void>(
		"/Documents/Bookmarks/RemoveBookmarks/",
		ids,
		{ signal }
	);
}

export interface BookmarkChangeSortOrderModel {
	id: number;
	sortOrder: number;
}

export function sortBookmarks(
	changeSortOrderModels: BookmarkChangeSortOrderModel[],
	signal?: AbortSignal
): Promise<BookmarkModel[]> {
	return environmentHttpClient.put<BookmarkModel[]>(
		"/Documents/Bookmarks/SortOrder",
		changeSortOrderModels,
		{ signal }
	);
}

export interface RenameBookmarkModel {
	id: number;
	name: string;
}

export function renameBookmark(
	data: RenameBookmarkModel,
	signal?: AbortSignal
): Promise<void> {
	return environmentHttpClient.put<void>(
		"/Documents/Bookmarks/RenameBookmark",
		data,
		{ signal }
	);
}

export interface SharePointBookmarkCreationModel {
	name: string;
	location: ListLocationModel;
	itemId: number;
}

export interface WebDavBookmarkCreationModel {
	name: string;
	serverId: number;
	fileId: string;
}

export function addSharePointBookmark(
	model: SharePointBookmarkCreationModel,
	signal?: AbortSignal
): Promise<BookmarkModel> {
	return environmentHttpClient.post<BookmarkModel>(
		"/Documents/Bookmarks/AddSharePointBookmark",
		model,
		{ signal }
	);
}

export function addWebDavBookmark(
	model: WebDavBookmarkCreationModel,
	signal?: AbortSignal
): Promise<BookmarkModel> {
	return environmentHttpClient.post<BookmarkModel>(
		"/Documents/Bookmarks/AddWebDavBookmark",
		model,
		{ signal }
	);
}
